import { NON_EMPTY } from 'core/constants';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { ICorporateLocationAutocomplete } from 'corporate/types';

export const getLocationsAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal,
  options: {
    mapResult?: (
      result: GetManyResponse<ICorporateLocationAutocomplete>
    ) => GetManyResponse<ICorporateLocationAutocomplete>;
  } = {}
): Promise<GetManyResponse<ICorporateLocationAutocomplete>> => {
  const defaultFilters = {
    name: NON_EMPTY,
  };

  const { data } = await partfinitiClient.get(
    `/corporate_v2/location/locations?${getQueryStringToSnakeCase(
      {
        ...requestPayload,
        filters: {
          ...defaultFilters,
          ...requestPayload?.filters,
        },
      },
      // An absent view_by[uom] means "no conversion" to the BE, but a serialised `undefined`
      // is read as a real unit nobody can convert to, which silently zeroes availability.
      { removeNullValues: true }
    )}`,
    signal
  );

  const result = mapRecordsFromServer<ICorporateLocationAutocomplete>(
    data.data,
    data.records_filtered
  );

  if (!options.mapResult) {
    return result;
  }

  return options.mapResult(result);
};
